import type { SVGProps } from 'react';

const SvgCustomIntegrations = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="custom-integrations">
      <path d="M1.52 20H15v3.42a.76.76 0 0 0 .41.67.8.8 0 0 0 .34.08.74.74 0 0 0 .45-.15l9.56-7.22a.8.8 0 0 0 .3-.59.74.74 0 0 0-.28-.59l-9.58-7.8a.73.73 0 0 0-.79-.09.72.72 0 0 0-.41.67v3.76H1.52A1.13 1.13 0 0 0 .4 13.29v5.62A1.12 1.12 0 0 0 1.52 20m.38-6.37h13.83a.75.75 0 0 0 .75-.75V10l7.59 6.21-7.59 5.74v-2.67a.76.76 0 0 0-.75-.75H1.9Z" />
      <path d="M15.57.73A15.22 15.22 0 0 0 1.82 9.31l1.35.69a13.8 13.8 0 1 1-.12 11.89l-1.35.61A15.3 15.3 0 1 0 15.57.73" />
    </g>
  </svg>
);

export default SvgCustomIntegrations;
